module.exports = __webpack_public_path__ + "media/boton.46fc726f.wav";